var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-2",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"start","justify":"center"}},[_c('v-col',[_c('d-header',{attrs:{"label":"Admin"}}),_c('v-row',[_c('v-col',{attrs:{"cols":"2"}},[_c('AdminMenu')],1),_c('v-col',{attrs:{"cols":"10"}},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }